import * as ko from "knockout";
import * as mapping from "knockout.mapping";
import { Address } from "./address";

export class SubscriptionDetail {
    Action: any;
    AddressId: any;
    AddressName: any;
    ChangedQuantity: any;
    Id: any;
    
    LastModified: any;
    LastSubscriptionDate: any;
    LastSubscriptionDateString: any;
    Name: any;
    NewspaperId: any;
    NewspaperName: any;
    OrderType: any;
    OriginalQuantity: any;
    ModifiedQuantity: any;
    Period: any;
    Price: any;
    RecipientName: any;
    RequestDate: any;
    RequestId: any;
    ResultQuantity: any;
    RoundedPrice: any;
    RoundedPriceString: any;
    StatusName: any;
    SubscriptionId: any;
    SubscriptionStartDate: any;
    SubscriptionStartDateString: any;
    IsNewRequest: any;

    PreviousAddressName: any;
    ModifiedAddressString: any;
    PreviousAddressId: any;
    PreviousSubscriptionDetailId: any;
    CanModify: any;
    SubscriptionDetailOrderType: any;
    PreviousName: any;
    IsSenderSide: any;
    BlockId: any;
    NewspaperOrderPeriod: any;
    IsRecipientNameEditable: any;
    ReciverRecipientName: any;
    SenderRecipientName: any;

    IsEditable: any;
    IsValidItem: any;

    constructor(json?: any) {
        this.Action = ko.observable<string>();
        this.AddressId = ko.observable<number>();
        this.AddressName = ko.observable<string>();
        this.ChangedQuantity = ko.observable<number>();
        this.Id = ko.observable<number>();
        this.IsRecipientNameEditable = ko.observable<boolean>();
        this.LastModified = ko.observable<string>();
        this.LastSubscriptionDate = ko.observable<string>();
        this.LastSubscriptionDateString = ko.observable<string>();
        this.Name = ko.observable<string>();
        this.NewspaperId = ko.observable<number>();
        this.NewspaperName = ko.observable<string>();
        this.OrderType = ko.observable<string>();
        this.OriginalQuantity = ko.observable<number>();
        this.ModifiedQuantity = ko.observable<number>();
        this.Period = ko.observable<string>();
        this.Price = ko.observable<number>();
        this.RecipientName = ko.observable<string>();
        this.RequestDate = ko.observable<string>();
        this.RequestId = ko.observable<number>();
        this.ResultQuantity = ko.observable<number>();
        this.RoundedPrice = ko.observable<number>();
        this.RoundedPriceString = ko.observable<string>();
        this.StatusName = ko.observable<string>();
        this.SubscriptionId = ko.observable<number>();
        this.SubscriptionStartDate = ko.observable<string>();
        this.SubscriptionStartDateString = ko.observable<string>();
        this.IsNewRequest = ko.observable<boolean>();
        this.IsEditable = ko.observable<boolean>();

        this.PreviousAddressName = ko.observable<string>();
        this.ModifiedAddressString = ko.observable<string>();
        this.PreviousAddressId = ko.observable<number>();
        this.PreviousSubscriptionDetailId = ko.observable<number>();
        this.CanModify = ko.observable<boolean>();
        this.SubscriptionDetailOrderType = ko.observable<string>();
        this.PreviousName = ko.observable<string>();
        this.IsSenderSide = ko.observable<boolean>();
        this.BlockId = ko.observable<number>();
        this.NewspaperOrderPeriod = ko.observable<string>();
        this.SenderRecipientName = ko.observable<string>();
        this.ReciverRecipientName = ko.observable<string>();


        this.AddressId.extend({
            required: true
        });
        this.NewspaperId.extend({
            required: true
        });
        this.ModifiedQuantity.extend({
            required: true,
            min: 1
        });
        this.Name.extend({
            required: true
        });

        this.IsValidItem = ko.pureComputed(() => {
            return this.AddressId.isValid()
                && this.NewspaperId.isValid()
                && this.ModifiedQuantity.isValid()
                && this.Name.isValid();
        });

        if (json) {
            mapping.fromJS(json, {}, this);
        }

    }

}